import React, { Component, ChangeEvent } from 'react';
import { FieldGroup } from '../components/FieldGroup';
import { observer, inject } from 'mobx-react';
import { Button } from 'react-bootstrap';
import AuthenticationStore from '../stores/AuthenticationStore';
import { Validator } from '../components/Validator';
import { required, isEmail, isAlpha, validateRuleMap } from '../utils/ValidatorRulesUtils';

type AccountState = {
  firstName: string,
  lastName: string,
  email: string,
  password: string
}

type CreateAccountProps = {
  authenticationStore: AuthenticationStore
}

@inject((allStores: any) => {
  return {
    authenticationStore: allStores.authenticationStore as AuthenticationStore
  };
})
@observer
class CreateAccount extends Component<CreateAccountProps, AccountState> {
  state: AccountState = {
    firstName: '',
    lastName: '',
    email: '',
    password: ''
  };

  updateField(name: string, event: ChangeEvent<EventTarget>) {
    const target = event.target as HTMLInputElement;
    //todo: update validateStatus
    this.setState({
      [name]: target.value
    } as AccountState);
  }

  addAccount = () => {
    const validState = validateRuleMap(CreateAccount.rules, this.state);

    if (!validState) {
      alert("Some fields are invalid.");
      return;
    }

    this.props.authenticationStore.addAccount(this.state);
  }

  static rules = {
    firstName: [required, isAlpha],
    lastName: [required, isAlpha],
    email: [required, isEmail],
    password: [required],
  };

  render() {
    const { createAccountMessage } = this.props.authenticationStore;
    const { rules } = CreateAccount;

    return (
      <form>
        <h1>Create Account</h1>
        <hr></hr>
        <div className="col-lg-4 col-md-6">
          <Validator rules={rules.firstName}
            fieldName='firstName' value={this.state.firstName} render={({ isValid, message }) => (
              <FieldGroup
                id='accountFirstName'
                type='text'
                label='First Name'
                onChange={this.updateField.bind(this, 'firstName')}
                value={this.state.firstName}
                isValid={isValid}
                message={message} 
                required
              />
            )}
          />
          <Validator rules={rules.lastName}
            fieldName='lastName' value={this.state.lastName} render={({ isValid, message }) => (
              <FieldGroup
                id='accountLastName'
                type='text'
                label='Last Name'
                onChange={this.updateField.bind(this, 'lastName')}
                value={this.state.lastName}
                isValid={isValid}
                message={message}
                required
                />)}
          />
          <Validator rules={rules.email}
            fieldName='email' value={this.state.email} render={({ isValid, message }) => (
              <FieldGroup
                id='accountEmail'
                type='text'
                label='Email'
                onChange={this.updateField.bind(this, 'email')}
                value={this.state.email}
                isValid={isValid}
                message={message}
                required
                />)}
          />
          <Validator rules={rules.password}
            fieldName='password' value={this.state.password} render={({ isValid, message }) => (
              <FieldGroup
                id='accountPassword'
                type='password'
                label='Password'
                onChange={this.updateField.bind(this, 'password')}
                value={this.state.password}
                isValid={isValid}
                message={message}
                required
                />)}
          />
          <Button bsStyle='primary' onClick={this.addAccount}>Add Account</Button>
          {
            createAccountMessage === null ? '' : <h5 className='text-center'>{createAccountMessage}</h5>
          }
        </div>
      </form>
    );
  }
}

export { CreateAccount };